import InvoiceRecommendations from '@/components/Invoice/InvoiceRecommendations.vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { differenceInDays } from 'date-fns'
import { OctagonAlert } from 'lucide-vue-next'
import { cn } from 'pejer/src/lib/utils'
import { h } from 'vue'
import { InvoicesEmbed } from '../tables/Invoices'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const invoicesColumns: ColumnDef<InvoicesEmbed.ListItem>[] = [
  {
    accessorKey: 'kidNorwayInvoice.customerName',
  },
  {
    accessorKey: 'kidNorwayInvoice.customerEmail',
  },
  {
    accessorKey: 'customer.name',
  },
  {
    accessorKey: 'description',
  },
  {
    accessorKey: 'grossAmount',
  },
  {
    accessorKey: 'kidNorwayInvoice.paidAmount',
  },
  {
    accessorKey: 'paymentID',
  },
  {
    accessorKey: 'fundsLocation',
  },
  {
    id: 'status',
    header: 'Status',
    meta: {
      group: 'Status',
    },
    size: 100,
    cell: ({ row }) => {
      return h(InvoiceRecommendations, { invoice: row.original })
    },
  },
  {
    accessorKey: 'kidNorwayInvoice.dueDate',
  },
  {
    id: 'daysOverdue',
    header: 'Dager over forfall',
    meta: {
      group: 'Forfall',
      hideHeaderInCell: true,
    },
    size: 100,
    cell: ({ row }) => {
      const dueDate = new Date(row.original.kidNorwayInvoice.dueDate)
      const daysOverdue = differenceInDays(Date.now(), dueDate)
      if (daysOverdue < 14) return null
      return h(
        'div',
        {
          class: cn('text-xs text-red-600 flex items-center gap-1'),
        },
        [h(OctagonAlert, { class: 'w-4 h-4' }), ` forfalt for ${daysOverdue} dager siden`]
      )
    },
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 75,
  },
]
